import React from 'react';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

const ArrowIcon = () => <MaskIcon category="Arrows" name="icon-small-chevron-down" size={20} className="arrow" />;

export default ArrowIcon;
